import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, input, inject, ElementRef, effect, Component, ViewEncapsulation, ChangeDetectionStrategy, Optional, NgModule } from '@angular/core';
import { Styles, StyleFactory } from '@js-dot/ui/style';
import { NgClassSwitch } from '@ng-dot/core';
import * as i2 from '@ng-dot/ui/ci24';
import { DotCi24Module } from '@ng-dot/ui/ci24';
import * as i6 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i4 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import { DotMoreLinksComponentBase } from '@ng-dot/ui/more-links';
import { DotTipDirective } from '@ng-dot/ui/tip';
import * as i3 from '@ng-dot/ui/trans';
import { DotTransDirective } from '@ng-dot/ui/trans';
import { DotUpDirective } from '@ng-dot/ux/up';
import * as i1 from '@ng-dot/ui/container';
const _c0 = ["*"];
function DotToMoreLinksComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r1.icon), i0.ɵɵsanitizeHtml);
  }
}
function DotToMoreLinksComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dot-ci24", 3);
  }
}
class DotToMoreLinksService extends Styles {
  media = new StyleFactory(amount => {
    return [`
				@container dot-frame (max-width: ${amount}px) {
					.dot-to-more-links._${amount} {
						.dot-more-links-toggle {
							display: inline-block;
							visibility: visible;
						}
						.dot-more-links-area {
							display: none;
						}
					}
				}
			`, `	
				@container dot-frame (min-width: ${amount}px) {
					.dot-to-more-links._${amount} {
		 				.dot-more-links-area {
							box-shadow: none;						
							hr {
								display: none;
							} 
						}				
					}
				}
				`];
  });
  constructor() {
    super();
  }
  static ɵfac = function DotToMoreLinksService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToMoreLinksService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotToMoreLinksService,
    factory: DotToMoreLinksService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToMoreLinksService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class DotToMoreLinksComponent extends DotMoreLinksComponentBase {
  _dotContainer;
  moreAt = input(960);
  _toMoreLinks = inject(DotToMoreLinksService);
  _sizeClass = new NgClassSwitch(inject(ElementRef));
  constructor(_dotContainer) {
    super();
    this._dotContainer = _dotContainer;
    // effect(() => {
    // 	const moreAt = this.moreAt();
    //
    // });
    effect(() => {
      const moreAt = this.moreAt();
      this._toMoreLinks.media.update(moreAt);
      this._sizeClass.set('_' + moreAt);
    });
  }
  static ɵfac = function DotToMoreLinksComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToMoreLinksComponent)(i0.ɵɵdirectiveInject(i1.DotContainerDirective, 8));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotToMoreLinksComponent,
    selectors: [["dot-to-more-links"]],
    hostAttrs: ["data-context", "", 1, "dot-to-more-links", "_js"],
    inputs: {
      moreAt: [1, "moreAt"]
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 7,
    vars: 5,
    consts: [["areaRef", ""], ["dot-link", "", "hidden", "", 1, "dot-more-links-toggle", 3, "click", "tip"], [3, "innerHTML"], ["type", "dots_vertical"], ["dotTrans", "o", 1, "dot-more-links-area", 3, "dotUp"]],
    template: function DotToMoreLinksComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 1);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵlistener("click", function DotToMoreLinksComponent_Template_button_click_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.toggle());
        });
        i0.ɵɵtemplate(2, DotToMoreLinksComponent_Conditional_2_Template, 2, 3, "span", 2)(3, DotToMoreLinksComponent_Conditional_3_Template, 1, 0, "dot-ci24", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4, 0);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("tip", i0.ɵɵpipeBind1(1, 3, ctx.tip$));
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.icon ? 2 : 3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dotUp", ctx.up);
      }
    },
    dependencies: () => [i2.DotCi24Component, i3.TransDirective, i4.DotLinkComponent, DotUpDirective, i5.AsyncPipe, i6.DotIconPipe],
    styles: [":root{--more-links-back: var(--b, #fff);--more-links-text: var(--t, #000)}.dot-more-links-area._show{position:fixed;display:flex;flex-direction:column;z-index:10000;background-color:var(--more-links-back);color:var(--more-links-text);padding:16px}.dot-more-links-area._show a,.dot-more-links-area._show button{display:block;min-width:100%;min-height:48px;text-align:left;white-space:nowrap;margin:0!important}.dot-more-links-area._show hr{display:block;border:1px solid currentColor;margin-left:10px;margin-right:10px}.dot-more-links-area._show .icon-label{display:inline!important}.dot-to-more-links .dot-more-links{position:relative}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToMoreLinksComponent, [{
    type: Component,
    args: [{
      selector: 'dot-to-more-links',
      template: `
		<button dot-link
				class="dot-more-links-toggle"
				(click)="toggle()"
				[tip]="tip$ | async"
				hidden
		>
			@if (icon) {
				<span [innerHTML]="icon | icon"></span>
			} @else {
				<dot-ci24 type="dots_vertical"></dot-ci24>
			}
		</button>
		<div class="dot-more-links-area" [dotUp]="up" dotTrans="o" #areaRef>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-to-more-links _js',
        'data-context': ''
      },
      standalone: false,
      styles: [":root{--more-links-back: var(--b, #fff);--more-links-text: var(--t, #000)}.dot-more-links-area._show{position:fixed;display:flex;flex-direction:column;z-index:10000;background-color:var(--more-links-back);color:var(--more-links-text);padding:16px}.dot-more-links-area._show a,.dot-more-links-area._show button{display:block;min-width:100%;min-height:48px;text-align:left;white-space:nowrap;margin:0!important}.dot-more-links-area._show hr{display:block;border:1px solid currentColor;margin-left:10px;margin-right:10px}.dot-more-links-area._show .icon-label{display:inline!important}.dot-to-more-links .dot-more-links{position:relative}\n"]
    }]
  }], () => [{
    type: i1.DotContainerDirective,
    decorators: [{
      type: Optional
    }]
  }], null);
})();
class DotToMoreLinksModule {
  static ɵfac = function DotToMoreLinksModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToMoreLinksModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotToMoreLinksModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, DotCi24Module, DotIconModule, DotTransDirective, DotLinkModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToMoreLinksModule, [{
    type: NgModule,
    args: [{
      declarations: [DotToMoreLinksComponent],
      imports: [CommonModule, DotCi24Module, DotIconModule, DotTransDirective, DotLinkModule, DotUpDirective, DotTipDirective],
      exports: [DotToMoreLinksComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotToMoreLinksComponent, DotToMoreLinksModule, DotToMoreLinksService };
